<template>
  <div @wheel="handleScroll" class="" id="blog">
    <v-touch
      class="position-relative h-100 d-flex flex-column flex-md-row align-items-md-stretch mr-md-3"
      @swipedown="handleScroll"
      @swipeup="handleScroll"
      @swipeleft="handleHorizontalScroll"
      @swiperight="handleHorizontalScroll"
    >
      <p :class="[titleStyle, 'pl-4']">{{ textTitle | translate }}</p>

      <div class="projects h-100 flex-grow-1">
          <portfolio-web-project v-if="serviceType === 'web'" :project="details" class="h-100 py-sm-4 "/>
          <portfolio-software-project v-else-if="serviceType === 'software'" :project="details" class="h-100 py-sm-4 "/>
          <portfolio-app-project  v-else-if="serviceType === 'app'" :project="details" class="h-100"/>
          <portfolio-design-project  v-else :project="details" class="h-100"/>
      </div>

      <navigation
        class="mt-auto mt-md-0 ml-md-auto"
        :current-index="parseInt(serviceId, 10)"
        :total="total"
        @change="changeItem"
      />

    </v-touch>
  </div>

</template>

<script>
  import AspectRatioBox from '../components/AspectRatioBox'
  import PortfolioAppProject from '../components/PortfolioAppProject'
  import PortfolioSoftwareProject from '../components/PortfolioSoftwareProject'
  import PortfolioWebProject from '../components/PortfolioWebProject'
  import PortfolioDesignProject from '../components/PortfolioDesignProject'
  /* eslint-disable  */
  import portafolio from '../config/portafolio'
  import navigation from '../components/NavigationModal.vue'
  import imgKeyboard from '../assets/images/portfolio/portfolioWeb/laptop_keyboard.webp'

  export default {
    components: { PortfolioDesignProject, PortfolioAppProject, PortfolioSoftwareProject, PortfolioWebProject, AspectRatioBox, navigation },
    name: 'WatchPortfolio',
    data () {
      return {
        imgKeyboard,
        // total: 0,
        //details: {}
      }
    },
    props: {
      serviceType: {
        type: String,
        default: 'web'
      },
      serviceId: 0
    },
    computed: {
      textTitle () {
        return `works.portfolio.contents.${this.serviceType}.title`
      },
      total () {
        return portafolio[this.serviceType].length
      },
      details () {
        const itemIndex = parseInt(this.serviceId, 10)
        return portafolio[this.serviceType][itemIndex]
      },
      xsClass () {
        return this.serviceType === 'web' ? 'img-web' : this.serviceType === 'software' ? 'img-soft' : 'img-else'
      },
      titleStyle () {
        return this.serviceType === 'web' ? 'title-web' : this.serviceType === 'app' ? 'title-app' : this.serviceType === 'software' ? 'title-soft' : 'title-dise'
      }
    },
    methods: {
      handleScroll (e) {
        let diff = -1
        if (
          (e.type === 'wheel' && e.deltaY < 0) ||
          e.type === 'swipeup'
        ) {
            diff = 1
        }
        this.changeItem(parseInt(this.serviceId, 10) + diff)
      },
      handleHorizontalScroll(e) {
        let diff = -1
        if (e.type === 'swipeleft') {
          diff = 1
        }
        this.changeItem(parseInt(this.serviceId, 10) + diff)
      },
      changeItem (index) {
        const newIndex = Math.min(Math.max(0, index), portafolio[this.serviceType].length - 1)
        if (newIndex !== parseInt(this.serviceId, 10)) {
          this.$router.push({ name: 'ServiceTypeId', params: { serviceType: this.serviceType, serviceId: newIndex } })
        }
      }
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/styles/colors';

  #blog {
    height: 85vh;
  }

  .titulo {
    // position: fixed;
    //top: -6vh;
    font-size: 3rem;
    color: #00839E;
    font-family: "Open Sans", sans-serif;
    font-weight: 800;
    z-index: 1;
    position: fixed;

    @media (max-width: 991.99px) {
      top: 0;
    }

    @media(min-width: 992px) {
      /*top: -3rem;*/
    }

    @media (min-width: 1100px) {
      /*font-size: 10.7rem;*/
    }

    @media (max-width: 1100px) {
      /*font-size: 8.7rem;*/
    }

    @media (max-width: 774px) {
      /*font-size: 4rem;*/
    }
  }

  .title-app {
    @extend .titulo;
    color: $light-orange;
  }

  .title-web, .title-soft, .title-dise {
    @extend .titulo;
    color: #00839e;
  }

  .title-soft {
    /*font-size: 4rem;*/

    @media(min-width: 992px) {
     /* top: -1.5rem;*/
    }

    @media (min-width: 1100px) {
      /*font-size: 6.7rem;*/
    }

    @media (max-width: 774px) {
      /*font-size: 3rem;*/
      // top: 1vh;
    }

    @media (max-width: 594px) {
      /*font-size: 3rem;*/
      //top: 1vh;
    }
  }

  .title-dise {
    @media(min-width: 992px) {
      /*top: -1.5rem;*/
    }

    @media (min-width: 1100px) {
      /*font-size: 6.7rem;*/
    }

    @media (max-width: 774px) {
      /*font-size: 3rem;*/
      /*top: 1vh;*/
    }

    @media (max-width: 594px) {
      /*font-size: 3rem;*/
      /*top: 1vh;*/
    }
  }

  .projects {
    flex-grow: 1;
    max-width: 80%;
    margin: auto;
    @media (max-width: 576px) {
      max-width: 100%;
      margin-top: calc(64px + 2rem);
    }
  }

  .text {
    font-family: "Open Sans", sans-serif;
    font-size: 1.3rem;
    text-shadow: 1px 2px #ffffff78;
    margin-top: -25px;

    .accent {
      font-family: "Open Sans", sans-serif;
      font-weight: 800;;
      font-size: 1.8rem;

      @media (min-width: 1400px) {
        font-size: 2.2rem;
      }
    }

    .orangeText {
      color: $light-orange;
    }

    .blueText {
      color: #00839E;
    }

    .curve {
      font-style: italic;
    }

    @media (min-width: 1400px) {
      font-size: 1.9rem
    }

    .small {
      font-size: 1rem;
      @media (min-width: 1400px) {
        font-size: 1.5rem
      }
    }

    .big {
      font-size: 1.2rem;

      @media (min-width: 1400px) {
        font-size: 2.2rem
      }
    }
  }

  .container-info {
    margin: auto;

    @media (max-width: 1200px) {
      box-shadow: 0 2px 20px rgba(0, 0, 0, .33);
      background-color: #EFF7FB;
    }
  }

  .slidedown-fade-enter-active, .slideup-fade-enter-active {
    transition: all .3s ease;
  }

  .slidedown-fade-leave-active, .slideup-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slidedown-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
  {
    transform: translateY(100%);
    opacity: 0;
  }

  .slideup-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
  {
    transform: translateY(-100%);
    opacity: 0;
  }

  .fade-enter-active, .fade-leave-active {
    transition: all .3s ease-in-out;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/pages/WatchPortfolio.vue